module.exports = __webpack_public_path__ + "fonts/social.e3f1a86.woff";